// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from "firebase/auth";
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Using the same Firebase project as the mobile app
// Project: xmas-app-fd793
const firebaseConfig = {
  apiKey: "AIzaSyDSh1CEisM-xf231_bP2urPGqhElzr4QhE",
  authDomain: "xmas-app-fd793.firebaseapp.com",
  projectId: "xmas-app-fd793",
  storageBucket: "xmas-app-fd793.firebasestorage.app",
  messagingSenderId: "827395793451",
  appId: "1:827395793451:web:5ac29144b34992a734406e",
  measurementId: "G-3RZMVH8HEW"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
